import type { GuideDefinition, GuideId } from '../engine';
import { quoteCreateGuide } from './quoteCreate';
import { workOrderCreateGuide } from './workOrderCreate';

export { quoteCreateGuide, workOrderCreateGuide };

export const GUIDES: Record<GuideId, GuideDefinition> = {
  'workOrder.create': workOrderCreateGuide,
  'quote.create': quoteCreateGuide,
};
